var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 640,
    viewBox: "0 0 480 480",
    width: 640,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 72c0 39.766-32.234 72-72 72s-72-32.234-72-72 32.234-72 72-72 72 32.234 72 72zm0 0",
    fill: "#bf4653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272 176h176c17.672 0 32 14.328 32 32s-14.328 32-32 32H32c-17.672 0-32-14.328-32-32s14.328-32 32-32h176",
    fill: "#bc8f6f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M448 200H32c-13.426 0-24.871 8.281-29.625 20 4.754 11.719 16.2 20 29.625 20h416c13.426 0 24.871-8.281 29.625-20-4.754-11.719-16.2-20-29.625-20zm0 0",
    fill: "#cb9e78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240 0c-17.672 0-32 14.328-32 32v160c0 17.672 14.328 32 32 32s32-14.328 32-32V32c0-17.672-14.328-32-32-32zm0 0",
    fill: "#52575f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228 2.375c-11.719 4.754-20 16.2-20 29.625v160c0 13.426 8.281 24.871 20 29.625 11.719-4.754 20-16.2 20-29.625V32c0-13.426-8.281-24.871-20-29.625zm0 0",
    fill: "#666d77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M448 240v208c0 17.672-14.328 32-32 32H64c-17.672 0-32-14.328-32-32V240",
    fill: "#bf4653"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64 480h350.871c.664-2.566 1.129-5.223 1.129-8V264H32v184c0 17.672 14.328 32 32 32zm0 0",
    fill: "#dc6068"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184 432c-13.258 0-24-10.742-24-24v-96c0-13.258 10.742-24 24-24s24 10.742 24 24v96c0 13.258-10.742 24-24 24zm0 0M104 432c-13.258 0-24-10.742-24-24v-96c0-13.258 10.742-24 24-24s24 10.742 24 24v96c0 13.258-10.742 24-24 24zm0 0M296 432c-13.258 0-24-10.742-24-24v-96c0-13.258 10.742-24 24-24s24 10.742 24 24v96c0 13.258-10.742 24-24 24zm0 0M376 432c-13.258 0-24-10.742-24-24v-96c0-13.258 10.742-24 24-24s24 10.742 24 24v96c0 13.258-10.742 24-24 24zm0 0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360 64h96v16h-96zm0 0",
    fill: "#eebc5a"
  })));
}

export default __webpack_public_path__ + "009a76ab6d72f688deeade37c21d2293.svg";
export { SvgShoppingCart as ReactComponent };